export default __webpack_public_path__ + "static/media/loading.8981e9a5.gif";